const AMAZON_HOST_PATTERN = /(^|\.)amazon\.[a-z.]+$/i

export function isAmazonUrl(value) {
  try {
    return AMAZON_HOST_PATTERN.test(new URL(value).hostname)
  } catch (error) {
    return false
  }
}

export function buildAffiliateUrl(value) {
  if (!value) return ''

  try {
    const url = new URL(value)
    url.searchParams.delete('subId')

    if (AMAZON_HOST_PATTERN.test(url.hostname)) {
      const associateTag = process.env.VUE_APP_AMAZON_ASSOCIATE_TAG
      if (associateTag) url.searchParams.set('tag', associateTag)
    }

    return url.toString()
  } catch (error) {
    return value
  }
}

export function isCashbackEligible(product) {
  if (!product || product.cashbackEnabled !== true) return false
  if (product.affiliateNetwork === 'amazon_associates') return false
  return !isAmazonUrl(product.link)
}

